PJQ.views.rfq.RFQList = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'rfq-list'),
        rfqId: null
    },
    events: {
        'click .btn-add-rfq': 'addRFQ',
        'click .btn-delete-rfq': 'deleteRFQClicked'
    },
    beforeFirstRender: async function () {
        this.isFetched = false;
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        if (this.collection == null) {
            this.collection = new PJQ.collections.rfq.RFQs(null, {
                projectId: this.options.project.get('projectId')
            });
        }

        if(!this.collection.isFetched) {
            await this.collection.fetch();
        }

        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();

        this.isFetched = true;
        this.render();
    },
    beforeRender: function(){
        if (!this.isFetched) {
            return;
        }

        this.options.isAdmin = PJQ.app.session.project.hasPermission('changeRequests.isAdmin');
    },
    renderData: function () {
        return {
            collection: this.collection,
            isFetched: this.isFetched,
            isAdmin: this.options.isAdmin,
            hideHeader: this.options.hideHeader
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.renderView();

        PJQ.app.session.project.off('rfqChanged');
        PJQ.app.session.project.on('rfqChanged', function (rfq) {
            this.collection.add(rfq);
            this.render();
        }, this);

        if (this.options.rfqId > 0) {
            let initRFQ = this.collection.get(this.options.rfqId);
            if (initRFQ != null) {
                this.viewRFQ(initRFQ);
                this.options.rfqId = null;
            }
        }
    },
    renderView: function () {
        if (this.dataTable) {
            this.dataTable.remove();
            this.dataTable = null;
        }

        this.dataTable = this.getDataTableInstance();
    },
    getDataTableInstance: function () {
        return new PJQ.views.rfq.RFQDataTable({
            el: this.$('.rfq-data'),
            rowId: "cid",
            data: this.collection.models,
            isAdmin: this.options.isAdmin,
            headerData: _.bind(function () {
                return {
                    project: this.options.project,
                    isAdmin: this.options.isAdmin
                };
            }, this),
            order: [[1, 'asc']],
            onViewRFQ: (rfq) => {
                this.viewRFQ(rfq);
            },
            onRowDoubleClick: (row) => {
                this.viewRFQ(row.data());
            },
            contextMenuOptions: {
                actions: [
                    {
                        name: 'View',
                        onClick: _.bind(function (row) {
                            this.viewRFQ(row.data());
                        }, this)
                    }
                ]
            }
        });
    },
    viewRFQClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.viewRFQ(row.data());
    },
    viewRFQ: function (rfq) {
        isNew = rfq == null;
        new PJQ.views.rfq.RFQEditModal({
            model: rfq,
            changeRequest: this.options.changeRequest,
            onSave: _.bind(function (rfq) {
                if (isNew) {
                    this.collection.add(rfq);
                }
                this.renderView();
            }, this),
            onDelete: _.bind(function (rfq) {
                this.collection.remove(rfq);
                this.renderView();
            }, this)
        });
    },
    addRFQ: function() {
        this.viewRFQ();
    },
    deleteRFQClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.deleteRFQ(row);
    },
    deleteRFQ: function (row) {
        if (row != null) {
            let rfq = row.data();
            if (rfq != null) {
                new PJQ.views.modals.DeleteCancel({
                    header: "Delete RFQ",
                    body: "Are you sure you want to delete this RFQ?",
                    onDelete: _.bind(function () {
                        rfq.destroy({
                            success: _.bind(function () {
                                this.dataTable.removeRow(row);
                                if (typeof this.options.onDelete === 'function') {
                                    this.options.onDelete(rfq);
                                }
                            }, this)
                        });
                    }, this)
                });
            }
        }
    }
});

PJQ.views.rfq.SelectRFQModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-select-rfqs'),
        width: '50%',
        maxWidth: 700,
        onSave: _.noop
    },
    events: {
        "change .select-rfq": "selectRFQ",
        "click .btn-save": "save",
        "click .btn-cancel": "cancel"
    },
    beforeModalCreated: function () {
        this.options.isAdmin = PJQ.app.session.project.hasPermission('changeRequests.isAdmin');
        this.selectedRFQs = [];

        if (this.collection == null) {
            this.collection = new PJQ.collections.rfq.RFQs();
        }

        this.render()

    },
    renderData: function() {
        return {
            headerSubText: this.options.headerSubText,
            isSingleChoice: this.options.isSingleChoice
        }
    },
    afterRender: function () {
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.rfqs-table'),
            data: this.rfqs,
            isHideSearch: true,
            order: [],
            columns: [{
                "data": "attributes.isSelected",
                "title": "",
                "orderable": false,
                "searchable": false,
                "render": _.bind(function (data) {
                    return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox" ' + (data ? 'checked' : '') + ' class="select-rfq"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                }, this)
            },
                {
                    "data": "attributes.number",
                    "title": "Number",
                    "orderable": true
                },
                {
                    "data": "attributes.client.companyName",
                    "title": "Client",
                    "orderable": true
                },
                {
                    "data": "attributes.description",
                    "title": "Description",
                    "orderable": false
                },
                {
                    "data": "attributes.amount",
                    "title": "Amount",
                    "orderable": false,
                    "className": "text-align-right",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.formatHelpers.formatCurrency(data);
                    }, this)
                }],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
        });
    },
    selectRFQ: function (e) {
        let target = $(e.currentTarget),
            rfq = this.dataTable.getRow(target.closest('tr')).data();

        if (this.options.isSingleChoice) {
            this.$('.select-rfq').not(target).text('Select').prop('checked', false);
            if (rfq.get('isSelected')) {
                rfq.set('isSelected', false);
                this.selectedRFQ = null;
            } else {
                rfq.set('isSelected', true);
                this.selectedRFQ = rfq;
                this.collection.get(rfq.id);
                _.each(this.collection.models, _.bind(function (dtRFQ) {
                    if (rfq.id !== dtRFQ.id)
                        dtRFQ.set('isSelected', false);
                }, this));
            }
            this.$('.btn-save').attr('disabled', this.selectedRFQ == null);

            if(typeof this.options.onRFQSelected === 'function') {
                this.options.onRFQSelected(this.selectedRFQ);
            }
        } else {
            if (rfq.get('isSelected')) {
                target.text('Select').addClass('btn-primary').removeClass('btn-secondary');
                rfq.set('isSelected', false);
                this.selectedRFQs = _.reject(this.selectedRFQs, function (selRFQ) {
                    return selRFQ.id === rfq.id;
                });
            } else {
                target.text('Deselect').addClass('btn-secondary').removeClass('btn-primary');
                rfq.set('isSelected', true);
                this.selectedRFQ.push(rfq);
            }
            this.$('.btn-save').attr('disabled', this.selectedRFQs == null);

            if(typeof this.options.onRFQSelected === 'function') {
                this.options.onRFQSelected(this.selectedRFQs);
            }
        }
    },
    cancel: function () {
        if (this.options.onCancel) {
            this.options.onCancel();
        }
        this.removeModal();
    },
    save: function () {
        if (this.options.onSave) {
            this.options.onSave(this.selectedRFQ ? this.selectedRFQ : this.selectedRFQs);
            this.removeModal();
        }
    }
});